import { functionService } from "services/function.service";

export const FUNCTION_SCOPE_EMPTY = {
    function_code: '',
    is_allowed: false,
    effective: {
        has_global: false,
        has_public: false,
        units: []
    }
};

const getScopePayload = (response) => {
    if (!response) return null;
    return response.detail || response.data || response;
};

export const normalizeFunctionScope = (response, functionCode = '') => {
    const payload = getScopePayload(response);
    const effective = payload?.effective || {};

    return {
        function_code: payload?.function_code || functionCode || FUNCTION_SCOPE_EMPTY.function_code,
        is_allowed: Boolean(payload?.is_allowed),
        effective: {
            has_global: Boolean(effective?.has_global),
            has_public: Boolean(effective?.has_public),
            units: Array.isArray(effective?.units) ? effective.units : []
        }
    };
};

export const getFunctionScope = async (functionCode) => {
    if (!functionCode) return normalizeFunctionScope(null);

    const response = await functionService.getFunctionScope(functionCode);
    return normalizeFunctionScope(response, functionCode);
};

export const isFunctionAllowed = (scope) => Boolean(scope?.is_allowed);

export const hasGlobalScope = (scope) => Boolean(scope?.effective?.has_global);

export const hasPublicScope = (scope) => Boolean(scope?.effective?.has_public);

export const getScopedUnits = (scope) => {
    if (!Array.isArray(scope?.effective?.units)) return [];
    return scope.effective.units;
};

export const getScopedUnitIds = (scope) => {
    return getScopedUnits(scope)
        .map((unit) => unit?.unitId)
        .filter((unitId) => unitId !== undefined && unitId !== null);
};

export const hasUnitScope = (scope, unitId) => {
    if (unitId === undefined || unitId === null) return false;
    return getScopedUnitIds(scope).some((item) => String(item) === String(unitId));
};

export const getFunctionScopeUiState = (scope) => {
    const normalizedScope = normalizeFunctionScope(scope);
    const units = getScopedUnits(normalizedScope);

    return {
        isAllowed: isFunctionAllowed(normalizedScope),
        hasGlobal: hasGlobalScope(normalizedScope),
        hasPublic: hasPublicScope(normalizedScope),
        units,
        unitIds: getScopedUnitIds(normalizedScope),
        canSelectGlobal: hasGlobalScope(normalizedScope),
        canSelectPublic: hasPublicScope(normalizedScope),
        canSelectUnit: units.length > 0 || hasGlobalScope(normalizedScope),
        canDoGlobal: hasGlobalScope(normalizedScope) || (hasPublicScope(normalizedScope) && units.length > 0)
    };
};
